import React from "react";
import { Quote } from "lucide-react";

const BG =
  "https://static.prod-images.emergentagent.com/jobs/ed7eee19-61aa-456b-86f7-01a2255b2ba0/images/c35ebb68ba8e76b19ab36834d1e00518926e8df6a77410c1ab2302e195adbab5.png";

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative border-b border-white/10 py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5 reveal">
          <div className="font-mono text-[11px] uppercase tracking-[0.32em] text-red-400 mb-6">
            /00 — Manifesto
          </div>
          <h2 className="font-heading text-4xl md:text-5xl font-bold uppercase tracking-tight leading-[0.95]">
            Thrones of <span className="text-red-500">iniquity</span> —
            built in code.
          </h2>
          <p className="mt-8 font-body text-base md:text-lg text-gray-300 leading-relaxed">
            We exist because algorithms now sit in the seat of judges. They throttle livelihoods,
            silence voices, and quietly extract from the unaware. Most of these systems have never
            been independently audited — and most operators have no map of their exposure.
          </p>
          <p className="mt-5 font-body text-base md:text-lg text-gray-300 leading-relaxed">
            High-Risk Algorithms exists to expose the corruption, name the mechanisms, and arm
            people and businesses with the counter-strategy.
          </p>
        </div>

        <div className="lg:col-span-7">
          <div className="relative border border-white/10 bg-[#0c0c0c] overflow-hidden reveal">
            <div
              className="absolute inset-0 opacity-20"
              style={{
                backgroundImage: `url(${BG})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            />
            <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/40 to-transparent" />

            <div className="relative p-10 md:p-14">
              <Quote className="text-red-500 mb-6" size={42} />
              <blockquote className="font-heading text-2xl md:text-3xl leading-snug text-white">
                “Shall the throne of iniquity have fellowship with thee, which frameth mischief
                by a law?”
              </blockquote>
              <div className="mt-6 font-mono text-xs uppercase tracking-[0.28em] text-red-400">
                Psalms 90:24 — cited by the founder
              </div>

              <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-6 border-t border-white/10 pt-8">
                {[
                  { k: "Expose", d: "Publish the mechanics of corrupt algorithms." },
                  { k: "Equip", d: "Hand businesses a real defensive playbook." },
                  { k: "Dethrone", d: "Build counter-systems that outrank them." },
                ].map((p) => (
                  <div key={p.k} data-testid={`pillar-${p.k.toLowerCase()}`}>
                    <div className="font-mono text-[11px] uppercase tracking-[0.28em] text-red-400">
                      {p.k}
                    </div>
                    <div className="mt-3 font-body text-sm text-gray-300 leading-relaxed">
                      {p.d}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
